<template>
  <div>
    <div class="container-fluid container-fluid--bg-red edge--bottom">
      <div class="row">
        <div class="col-sm">
          <transition-group appear name="fade" :duration="500">
            <h1 :key="title">{{ title }}</h1>
            <div :key="content[0]">
              <p>{{ content[0] }} <a :href="links[0]" target="_blank">Outlook </a>, <router-link to="./create-apple-email-signature">Apple Mail</router-link>, {{ content[1] }}</p><br><br>
            </div>
          </transition-group>
        </div>
      </div>
    </div>
    <section class="container-fluid container-full">
    </section>
    <div class="container container__signature">
      <transition appear name="fade" :duration="500">
        <signature-form></signature-form>  
      </transition>
    </div>
  </div>
</template>

<script>
  import SignatureForm from './Signature-Form'
  
  export default {
    name: 'signature',
    data () {
      return {
        title: 'Tuff Shed Email Signature Tool',
        content: [
          'Use this tool to create your Tuff Shed email signature, then simply add it to',
          'or any other email client of your choice.'
        ],
        links: [
          'https://support.office.com/en-us/article/Add-a-signature-to-messages-8ee5d4f4-68fd-464a-a1c1-0e1c80bb27f2',
          './create-apple-email-signature'
        ]
      }
    },
    components: {
      SignatureForm
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .container {
    &container__signature {
      margin-top: 0;
    }
  }

  .container__signature {
    margin-top: -325px;
    margin-bottom: 50px;
    z-index: 99;

    @media screen and (max-width: 425px) {
      margin-top: -250px;
    }
  }

</style>